import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getArbitros } from '../services/api';

export default function Arbitros() {
  const navigate            = useNavigate();
  const [arbitros, setArbitros] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    setCargando(true);
    getArbitros()
      .then(data => { if (Array.isArray(data)) setArbitros(data); })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  function getIniciales(nombre) {
    if (!nombre) return '??';
    return nombre.split(' ').filter(p => p.length > 0).slice(0,2).map(p => p[0].toUpperCase()).join('');
  }

  return (
    <div style={styles.pagina}>

      <div style={styles.header}>
        <div style={styles.headerInner}>
          <div>
            <div style={styles.titulo}>Árbitros certificados</div>
            <div style={styles.sub}>
              {cargando ? 'Cargando...' : `${arbitros.length} árbitros disponibles`}
            </div>
          </div>
          <button style={styles.btnRegistrar} onClick={() => navigate('/registro-arbitro')}>
            ¿Eres árbitro? Regístrate →
          </button>
        </div>
      </div>

      <div style={styles.contenido}>
        {cargando ? (
          <div style={styles.cargando}>Cargando árbitros...</div>
        ) : arbitros.length === 0 ? (
          <div style={styles.vacio}>
            <div style={styles.vacioIcono}>🟡</div>
            <div style={styles.vacioTitulo}>Sin árbitros registrados aún</div>
            <div style={styles.vacioSub}>
              Sé el primero en registrarte como árbitro en TuRival.
            </div>
            <button style={styles.btnRegistrarGrande} onClick={() => navigate('/registro-arbitro')}>
              Registrarme como árbitro →
            </button>
          </div>
        ) : (
          <>
            {arbitros.map((a, i) => (
              <div key={a.id || i} style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={styles.crest}>{getIniciales(a.nombre)}</div>
                  <div style={styles.info}>
                    <div style={styles.nombre}>{a.nombre}</div>
                    <div style={styles.meta}>
                      📍 {a.zona}
                      {a.experiencia ? ` · ${a.experiencia} años de exp.` : ''}
                    </div>
                    <div style={styles.badges}>
                      {a.certificado && <span style={styles.badgeCert}>✓ Certificado</span>}
                      {a.federado    && <span style={styles.badgeFed}>✓ Federado</span>}
                    </div>
                  </div>
                  <div style={styles.tarifaWrap}>
                    <div style={styles.tarifaNum}>
                      ${(a.tarifa || 0).toLocaleString('es-CL')}
                    </div>
                    <div style={styles.tarifaLabel}>por partido</div>
                  </div>
                </div>

                {a.modalidades?.length > 0 && (
                  <div style={styles.seccion}>
                    <div style={styles.seccionLabel}>Modalidades</div>
                    <div style={styles.tagsRow}>
                      {a.modalidades.map(m => (
                        <span key={m} style={styles.tag}>
                          {m === 'futbol5'  ? 'Fútbol 5'  :
                           m === 'futbol7'  ? 'Fútbol 7'  :
                           m === 'futbol11' ? 'Fútbol 11' : m}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {a.dias?.length > 0 && (
                  <div style={styles.seccion}>
                    <div style={styles.seccionLabel}>Disponibilidad</div>
                    <div style={styles.tagsRow}>
                      {a.dias.map(d => (
                        <span key={d} style={styles.tagAzul}>{d}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}

            <div style={styles.registrarCard} onClick={() => navigate('/registro-arbitro')}>
              <div style={styles.registrarIcono}>+</div>
              <div style={styles.registrarTitulo}>Regístrate como árbitro</div>
              <div style={styles.registrarSub}>
                Llega a cientos de equipos activos en tu zona.
              </div>
              <div style={styles.registrarBtn}>Registrarme →</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA' },
  header: {
    background: '#0D1117', padding: '24px 32px',
    borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 24,
  },
  headerInner: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 4,
  },
  sub: { fontSize: 13, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif" },
  btnRegistrar: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 10, padding: '10px 18px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
  },
  contenido: {
    padding: '0 32px 32px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
    gap: 16,
  },
  cargando: {
    gridColumn: '1 / -1', textAlign: 'center', padding: '60px',
    fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif",
  },
  vacio: {
    gridColumn: '1 / -1', textAlign: 'center', padding: '60px 20px',
  },
  vacioIcono: { fontSize: 56, marginBottom: 16 },
  vacioTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 8,
  },
  vacioSub: {
    fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif",
    maxWidth: 400, margin: '0 auto 24px', lineHeight: 1.6,
  },
  btnRegistrarGrande: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 12, padding: '13px 28px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, cursor: 'pointer',
  },
  card: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 16, padding: '20px',
  },
  cardHeader: { display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 16 },
  crest: {
    width: 48, height: 48, borderRadius: 12, flexShrink: 0,
    background: '#0D1117',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white',
  },
  info: { flex: 1 },
  nombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800, color: '#141922', marginBottom: 3,
  },
  meta: { fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 6 },
  badges: { display: 'flex', gap: 5, flexWrap: 'wrap' },
  badgeCert: {
    background: '#F0FDF4', color: '#16A34A',
    fontSize: 10, fontWeight: 700, padding: '2px 8px',
    borderRadius: 20, fontFamily: "'Barlow', sans-serif",
  },
  badgeFed: {
    background: '#EFF5FF', color: '#1A6BFF',
    fontSize: 10, fontWeight: 700, padding: '2px 8px',
    borderRadius: 20, fontFamily: "'Barlow', sans-serif",
  },
  tarifaWrap: { textAlign: 'right', flexShrink: 0 },
  tarifaNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: '#FF6B1A', lineHeight: 1,
  },
  tarifaLabel: {
    fontSize: 10, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif",
    textTransform: 'uppercase', letterSpacing: '0.04em',
  },
  seccion: { marginBottom: 12 },
  seccionLabel: {
    fontSize: 10, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  tagsRow: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  tag: {
    background: '#F4F6FA', border: '1px solid #E8ECF4',
    borderRadius: 6, padding: '3px 9px',
    fontSize: 11, fontWeight: 600, color: '#4A5568',
    fontFamily: "'Barlow', sans-serif",
  },
  tagAzul: {
    background: '#EFF5FF', border: '1px solid #DBEAFE',
    borderRadius: 6, padding: '3px 9px',
    fontSize: 11, fontWeight: 600, color: '#1e40af',
    fontFamily: "'Barlow', sans-serif",
  },
  registrarCard: {
    background: '#0D1117', border: '2px dashed rgba(255,255,255,0.1)',
    borderRadius: 16, padding: '32px 20px', textAlign: 'center',
    cursor: 'pointer', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 10,
  },
  registrarIcono: {
    width: 48, height: 48, borderRadius: '50%',
    background: 'rgba(255,107,26,0.15)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, color: '#FF6B1A', fontWeight: 700,
  },
  registrarTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white',
  },
  registrarSub: {
    fontSize: 12, color: 'rgba(255,255,255,0.35)',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.5, maxWidth: 260,
  },
  registrarBtn: {
    fontSize: 13, fontWeight: 700, color: '#FF6B1A',
    fontFamily: "'Barlow Condensed', sans-serif", marginTop: 4,
  },
};